const HeaderTitle = (props) => {
  return (
    <h2>
      {props.title}
    </h2>
  )
}

export default HeaderTitle
